/**
 * @fileoverview Public tools — the Spanish (ES) bundle (LINKABLE-ASSETS-001 C1).
 * @package @puffin-core/public-tools
 *
 * The same leaves as `en.js`, in the same order. Machine-translated and unreviewed: `_meta.js` flags
 * every leaf `'machine'`, which IS the review queue. Formal "usted" register, as the ecosystem's
 * Spanish catalogs use.
 */

export const PUBLIC_TOOLS_ES = Object.freeze({
  // The page frame
  breadcrumbsLabel: 'Usted está aquí',
  relatedHeading: 'Herramientas relacionadas',

  // The provenance stamp
  provenanceLabel: 'Acerca de esta información',
  lastVerified: 'Última verificación: {date}',
  version: 'Versión {version}',
  sourcePrefix: 'Fuente:',
  disclaimerLegal:
    'Esta es información general, no asesoramiento legal. Consulte la fuente citada y a su propio asesor antes de actuar.',
  disclaimerPublishedRates:
    'Tarifas de lista publicadas; se excluyen los recargos por combustible y los recargos accesorios. Rige la guía vigente del transportista.',
  disclaimerPublishedSchedule:
    'Estas fechas son la guía publicada por el transportista para los Estados Unidos contiguos, salvo que se indique lo contrario; no son una garantía de entrega. Rige el aviso vigente del transportista.',

  // The calculator
  calculateSubmit: 'Calcular',
  calculateReset: 'Empezar de nuevo',
  resultsLabel: 'Resultados',
  error_fieldRequired: 'Escriba un valor.',
  error_fieldNumber: 'Escriba un número.',
  error_fieldMin: 'Escriba un número de al menos {min}.',
  error_fieldMax: 'Escriba un número que no sea mayor que {max}.',
  error_fieldPattern: 'Escriba un valor con el formato esperado.',
});
